import axios from "axios";
import { dynamicConfig } from "../../components/DynamicRoutes";
import { getToken } from "../../helpers";
import { publishRedirect } from "../Events/utils.events";
import trackEvent from "../LoginV2/Helpers/analyticsMap";
import logger from "../../logger";
import { getStorageItem } from "../../helpers/storageManager";

function getPlanIdFromQueryParams(qs) {
  let planId;
  let paramString = qs?.split('?').length > 0 ? qs?.split('?')[1] : null;
  if (paramString) {
    let params_arr = paramString.split('&') || [paramString];

    for (let i = 0; i < params_arr.length; i++) {
      let pair = params_arr[i]?.split('=');
      if (pair.includes('plansId') || pair.includes('planId') || pair.includes('TVE') ||  pair.includes('tve')) {
        planId = pair[1]
      };
    }
  }
  return planId;
}
export const pushToNextRoute = async (navigateRef) => {
  let routeState = getStorageItem("routeState")
  let isSkipped = false
  let nextRoute = await dynamicConfig(routeState, location?.pathname,isSkipped)
  publishRedirect(nextRoute)
}
export const accessVerify = async (hba) => {
  try {
      let latitude = hba?.latitude
      let longitude = hba?.longitude
    let token = await getToken(token => {return token})
      let res = await axios({
      method: 'GET',
      url: `${ apiBaseUrl }/v3/purchase/plan/verify-access`,
      params: {
        latitude,
        longitude
      },
      headers: { 
        Authorization: token
      }
      })
      return res?.data
  }
  catch(e) {
    logger(e, "error")
  }
}

const handlePlanClick = async (plan) => {
  let isRedirected = getStorageItem("isRedirected")
  sessionStorage.setItem("currentPlan", JSON.stringify(plan))
  trackEvent(type, {
    currency: plan && plan.planDetails && plan.planDetails[0] && plan.planDetails[0].recurringPaymentCurrencyCode, items: [
      {
        item_id: plan?.id,
        item_name: plan?.name,
        price: plan && plan.planDetails && plan.planDetails[0] && plan.planDetails[0].recurringPaymentAmount,
        quantity: 1
      }
    ],
  },null)
  if (isRedirected?.redirect) {
    return isRedirected?.path
  }
}

const updateArrowState = (container) => {
  const scrollLeft = container?.scrollLeft
  const maxScrollLeft = (container?.scrollWidth - container?.clientWidth)

  const leftArrow = document.querySelector('.left-arrow')
  const rightArrow = document.querySelector('.right-arrow')

  if(scrollLeft > 0){
    leftArrow?.classList.remove('disabled')
  } else {
    leftArrow?.classList.add('disabled')
  }

  if (scrollLeft >= maxScrollLeft - 1) {
    rightArrow.classList.add('disabled')
  } else {
    rightArrow.classList.remove('disabled')
  }

}
export { getPlanIdFromQueryParams, handlePlanClick, updateArrowState }